module.exports = __webpack_public_path__ + "static/media/about.8a020867.png";